var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"ys-title"},[_vm._v("重庆火锅产业要素交易平台隐私政策")]),_vm._m(0),_c('div',{staticClass:"flexCol alit"},[_c('div',{staticClass:"ys-content",domProps:{"innerHTML":_vm._s(_vm.wordText)}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justb"},[_c('div',{}),_c('div',{staticClass:"gxsj"},[_vm._v("本版更新日期：2024年3月24日")])])
}]

export { render, staticRenderFns }